import { Outlet } from "react-router-dom";
import { Header } from "@/components/public/Header";
import { Footer } from "@/components/public/Footer";
import { MobileBottomNav } from "@/components/public/MobileBottomNav";
import { BreakingAlert } from "@/components/public/BreakingAlert";
import { CountryBar } from "@/components/public/CountryBar";
import { SeoGlobal } from "@/components/public/SeoGlobal";
import { CookieConsent } from "@/components/public/CookieConsent";
import { usePageViewTracking } from "@/hooks/useAnalytics";
import { PaysFiltreProvider } from "@/lib/paysFilter";



function PublicLayout() {
  usePageViewTracking();
  return (
    <PaysFiltreProvider>
      <SeoGlobal />
      <div className="flex min-h-screen flex-col bg-background">
        <BreakingAlert />
        <Header />
        <CountryBar />
        {/* pb-20 couvre la hauteur de MobileBottomNav ; +env(safe-area-inset-bottom)
            car ce dernier grandit d'autant sur les écrans à encoche/barre de gestes.
            Le padding doit envelopper main ET Footer (pas seulement main) — sans
            ça, la nav fixe du bas masque le bas du footer, pas seulement le
            contenu de la page. */}
        <div className="flex flex-1 flex-col pb-[calc(5rem+env(safe-area-inset-bottom))] md:pb-0">
          <main className="flex-1">
            <Outlet />
          </main>
          <Footer />
        </div>
        <MobileBottomNav />
        <CookieConsent />
      </div>
    </PaysFiltreProvider>
  );
}

export default PublicLayout;
